module.exports = __webpack_public_path__ + "static/media/reversecover-2.705cddf2.png";